import * as angular from 'angular';
import FlowsActiveBridge from './FlowsActiveBridge';
/**
 * @ngdoc module
 * @name flowingly.runner.flows.active
 * @module flowingly.runner.flows.active
 * @description This module configures the page used to display flows that can be started.
 */
angular
  .module('flowingly.runner.flows.active', [])
  .component('flowsActive', FlowsActiveBridge);
